var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "text-white" }, [
        _c(
          "a",
          {
            staticClass: "px-2",
            attrs: { target: "_blank", href: "https://www.cds-global.com/" }
          },
          [_vm._v("CDS Global")]
        ),
        _vm._v("| 1901 Bell Avenue | Des Moines, IA 50315\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-white" }, [
        _vm._v("\n    © 2018 All Rights Reserved |\n    "),
        _c(
          "a",
          {
            staticClass: "px-2",
            attrs: {
              target: "_blank",
              href: "https://www.cds-global.com/company/privacy-notice"
            }
          },
          [_vm._v("Privacy Policy")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }